import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UserState {
  hash?: string
  jwt?: string
  email?: string
  firstName?: string
  lastName?: string
  userId?: string
  isUpsell?: boolean
}

const initialState: UserState = {}

const userSlice = createSlice({
  name: 'hash',
  initialState,
  reducers: {
    setUserData(state, action: PayloadAction<UserState>) {
      return {
        ...state,
        hash: action.payload.hash,
        email: action.payload.email,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        userId: action.payload.userId,
      }
    },
    setUserJwt(state, action: PayloadAction<UserState['jwt']>) {
      return { ...state, jwt: action.payload }
    },
    setIsUpsell(state, action: PayloadAction<boolean>) {
      return { ...state, isUpsell: action.payload }
    },
  },
})

export const { setUserData, setUserJwt, setIsUpsell } = userSlice.actions
export default userSlice.reducer
